import { MODULE_TYPES } from 'constants/common'
import SectionTypes from 'store/actionTypes/section'
import UserTypes from 'store/actionTypes/user'
import { getTranslationSections } from '../mapping/shared'

const initialData = {
  list: [],
  current: {},
  systems: [],
  pagination: {},
  filter: {
    [MODULE_TYPES.CIXI_CENTER]: {},
    [MODULE_TYPES.MOBILE_APP]: {},
    [MODULE_TYPES.SHOWCASE_WEB]: {}
  },
  components: {
    list: [],
    pagination: {}
  },
  sectionLanguages: {}
}

const Section = (state = initialData, action = {}) => {
  const { payload, type } = action
  switch (type) {
    case SectionTypes.GET_SECTIONS_SUCCESS:
      return { ...state, list: payload?.items, pagination: payload?.meta }
    case SectionTypes.GET_SECTION_DETAIL_SUCCESS:
      return { ...state, current: payload }
    case SectionTypes.UPDATE_SECTION_LANGUAGES_SUCCESS:
      return {
        ...state,
        sectionLanguages: {
          ...state.sectionLanguages,
          [payload?.sectionId]: payload?.languageIds
        }
      }
    case SectionTypes.UPDATE_FILTER_SECTION_SUCCESS:
      return {
        ...state,
        filter: {
          ...state.filter,
          [payload?.moduleName]: payload?.data
        }
      }
    case SectionTypes.GET_COMPONENTS_SUCCESS:
      return {
        ...state,
        components: {
          list: payload?.items,
          pagination: payload?.meta
        }
      }
    case SectionTypes.GET_SYSTEM_SECTIONS_SUCCESS:
      return {
        ...state,
        systems: getTranslationSections(payload?.sections)
      }
    case UserTypes.LOGOUT_SUCCESS:
      return { ...initialData, systems: state.systems }
    default:
      return state
  }
}

export default Section
